module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/backArrow@2x-b13f1938cbe7efbd87f6ec147a0a8e06.png";